<template>
    <main>
        <SliceZone :slices="slices" :components="components" />
    </main>
</template>

<script setup lang="ts">
    import {inject, ref} from 'vue';
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData} from '#app';
    import {useHead, definePageMeta, useWebsitePageView, createError} from '#imports';
    import {usePrismicDocument} from '~/composables/content/usePrismicDocument';
    import type {MicrodataRecord} from '~/composables/microdataFormatter';
    import {microdataFormatter} from '~/composables/microdataFormatter';
    import {useABTestSlices} from '~/composables/useABTestSlices';
    import {HOST_SETTINGS, PRISMIC_DOCUMENT} from '~/keys';
    import {components} from '~/slices/components';

    const hostSetting = inject(HOST_SETTINGS);
    const microData = microdataFormatter().formatMicrodata(hostSetting);

    const {fetchDocument} = usePrismicDocument('homepage');
    const document = inject(PRISMIC_DOCUMENT, ref());
    const {data, error} = await useAsyncData('homepage', () => fetchDocument());
    if (error.value) {
        throw createError(error.value);
    }
    document.value = data.value!;

    const {slices} = useABTestSlices(document.value);

    if (microData) {
        useHead({
            script: microData.map(microdataToScript),
        });
    }

    function microdataToScript(record: MicrodataRecord) {
        return {
            type: 'application/ld+json' as const,
            innerHTML: JSON.stringify(record, null, 2),
        };
    }

    definePageMeta({
        middleware: 'redirect-to-home',
    });

    useWebsitePageView('cms', 'homepage');
</script>
